import React, { useEffect, useState } from "react";

import { format, toDate, parse } from 'date-fns';
import Layout from "../../../layout";
import Dialog from "./modal";
import {
  danger,
  success,
  showLoading,
} from "../../../components/show-notification";

import api from "../../../providers/api";

import LoadingPanel from "../../../components/loading-painel";

const CalculoGeradoListar = () => {
  const [state, setState] = useState([]);

  const carregarDados = async () => {
    try {
      showLoading(".ibox-content");

      const requisicao = await api.get("/usuario-calculos");

      const { data } = requisicao;

      if (!data.status) {
        danger(data.mensagem);
        return;
      }

      if (!data.data) {
        return;
      }

      setState(data.data);
      window.$("#table-link").footable();
      showLoading(".ibox-content");
    } catch (error) {
      console.log(error);
      showLoading(".ibox-content");
      danger("Erro ao carregar os dados dos cálculos");
    }
  };

  const formatarJSON = (jsonObj) => {
    // const minhaString = 'Primeira linha.<br />Segunda linha.';
    const minhaString = jsonObj.replace('{', '').replace('}', '').replace(', ', '<br />').replace(', ', '<br />').replaceAll(', ', '<br />')
    return <div dangerouslySetInnerHTML={{ __html: minhaString }} />;
  };

  useEffect(() => carregarDados(), []);

  return (
    <>
      <Layout
        titulo="Ibraflex - Cálculos Gerados"
        header="Listagem de Cálculos Gerados"
      >
        <div className="row">
          <div className="col-lg-12">
            <div className="ibox">
              <div className="ibox-title">
                <h5>Listagem dos cálculos gerados no aplicativo</h5>
              </div>
              <div className="ibox-content">
                <LoadingPanel />
                {state.length <= 0 ? (
                  <>
                    <input
                      type="text"
                      className="form-control form-control-sm m-b-xs"
                      id="filter"
                      placeholder="Pesquisar na tabela"
                    ></input>
                    <table
                      id="table-link"
                      className="footable table table-stripped toggle-arrow-tiny"
                      data-filter="#filter"
                    >
                      <thead>
                        <tr>
                          <th data-toggle="true" data-type="numeric">
                            #
                          </th>
                          <th>Usuário</th>
                          <th>Data</th>
                          <th>Cálculo</th>
                        </tr>
                      </thead>
                    </table>
                  </>
                ) : (
                  <>
                    <input
                      type="text"
                      className="form-control form-control-sm m-b-xs"
                      id="filter"
                      placeholder="Pesquisar na tabela"
                    ></input>
                    <table
                      id="table-link"
                      className="footable table table-stripped toggle-arrow-tiny"
                      data-filter="#filter"
                    >
                      <thead>
                        <tr>
                          <th data-toggle="true" data-type="numeric">
                            #
                          </th>
                          <th style={{ width: '35%'}}>Dados do Usuário</th>
                          <th style={{ width: '15%'}}>Data</th>
                          <th style={{ width: '50%'}}>Dados do Cálculo</th>
                        </tr>
                      </thead>
                      <tbody>
                        {state.map((calculo) => (
                          <tr key={calculo.id}>
                            <th data-toggle="true" data-type="numeric">
                            #
                          </th>
                            <td>
                            <div className="row">
                                <div className="col-lg-12">
                                  <b>Usuário:</b> {calculo.nome}<br/>
                                  <b>Empresa:</b> {calculo.nome_empresa}<br/>
                                  <b>Telefone:</b> {calculo.telefone}<br/>
                                  <b>E-mail:</b> {calculo.email}<br/>                              
                                </div>
                              </div>
                            </td>
                            <td>
                              {format(new Date(calculo.created_at), 'dd/MM/yyyy HH:mm')}
                            </td>
                            <td>
                              {calculo.calculo_realizado !== null ? formatarJSON(calculo.calculo_realizado) : ''}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                      <tfoot>
                        <tr>
                          <td colSpan="3">
                            <ul className="pagination float-right"></ul>
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
};

export default CalculoGeradoListar;
